/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';

export default class FrameLoginRoute extends Route {
  model(params: { redirect_url: string }) {
    return {
      redirect_url: decodeURIComponent(params.redirect_url),
    };
  }
}
